import { Image } from "lucide-react";

// F-Z (2026-10-06): what visitors see where an exhibit or zone has no cover
// image yet — a neutral tile with a faint picture icon (18% white, approved by
// KL). Replaces the Exhibit Code that used to fill the tile: codes are not
// shown to visitors, since not every exhibition prints them.
export default function CoverPlaceholder({
  className = "",
  iconClassName = "w-1/3 h-1/3",
  testId,
}) {
  return (
    <div
      className={`bg-white/5 flex items-center justify-center ${className}`}
      data-testid={testId}
      aria-hidden="true"
    >
      <Image
        className={`${iconClassName} text-white/[0.18]`}
        strokeWidth={1.5}
      />
    </div>
  );
}
